/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'faction/rebellion': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" fill-rule="evenodd" d="M64 10C34.18 10 10 34.18 10 64s24.18 54 54 54 54-24.18 54-54S93.82 10 64 10zm0 2c28.72 0 52 23.28 52 52s-23.28 52-52 52S12 92.72 12 64 35.28 12 64 12z"/><path pid="1" d="M64 20l9 31 33 9-37 3z"/><path pid="2" d="M59 65l37 3-33 9-9 31z"/><path pid="3" d="M58 62L22 64l33-9 9-31z"/><path pid="4" d="M28 94l24-24 2 2-24 24zM74 56l24-24 2 2-24 24z"/>'
  }
})
